<template lang="html">

  <!-- La API responde 200 aunque la categoria no exista, asi que sin esto la
       pagina servia las claves de traduccion crudas en el intro y en la miga. -->
  <error-404 v-if="notFound"></error-404>
  <div class="categoria-blog blog" v-else>


    <intro :data="nombreCategoria"></intro>

    <section class="destacados posts-cat">
      <div class="container">
        <p class="breadcrumb"><router-link :to="`/${this.lang}/${$t('enlaces.blog')}`">{{$t('enlaces.textos.blog')}}</router-link> / {{nombreCategoria}}</p>
        <div class="flex wrap justify-around pad-sec-pb0">
         <template v-if="!!noticias">
           <noticia-el v-if="e.titulo != null" v-for="(e, key) in showPrimeras" :data="e" :key="key"></noticia-el>
        </template>

        
        <template v-if="noticias.length == 0 && !no_post">
          <h2 class="title title-76">{{$t('blog.no_hay_post')}}</h2>
        </template>
      </div>
      <div class="btn-leer">
         <span class="btn btn-dark" v-if="contador < noticias.length" v-on:click="showMore">{{$t('genericos.leer_mas')}}</span>
      </div>
    </div>
  </section>


  <ultimas-noticias :small="true"></ultimas-noticias>


</div>



</template>

<script lang="js">

  import Intro from '@/components/view-parts/intros/blog'

  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import { mapGetters } from 'vuex'

  Vue.use(VueAxios, axios);

  import Noticia_el from '@/components/parts/noticia-el';
  import Ultimas_noticias from '@/components/view-parts/actualidad-parts/noticias'
  import Error404 from '@/components/views/error-404'
  import {
    HTTP_NOT_FOUND,
    HTTP_SERVICE_UNAVAILABLE,
    NOT_FOUND_ROUTE,
    applyPrerenderStatus,
    applyRobots,
    clearCanonicalAndAlternates,
  } from '@/seo/head'

  export default  {
    name: 'categoria-blog',
    props: [],
    mounted() {
      this.loadCategoria();
   },
   beforeDestroy() {
     // Al mostrar la 404 se destruye el arbol, pero las peticiones en vuelo
     // siguen resolviendo: sin esto tocarian un componente ya desmontado.
     this.destroyed = true;
   },
   data() {
    return {
      noticias : '',
      no_post : false,
      contador : 9,
      notFound : false,
      // Nombre que da el backend, para las categorias sin traduccion.
      nombreBackend : '',
      destroyed : false
    }
  },
  methods: {
    showMore(){
    return this.contador = this.contador + 9
    },
    /**
     * Carga la categoria y comprueba que existe de verdad.
     *
     * `GET /blog/<slug>` responde 200 tanto si la categoria existe como si no,
     * pero el cuerpo distingue: devuelve `{noticias: [...]}` cuando existe y
     * `{mensaje: "no existe esta categoria", code: 0}` cuando no.
     *
     * Se valida contra el backend y NO contra `translations`: la categoria
     * `importacion` existe en el CMS y no esta traducida, asi que validando por
     * traduccion recibiria un 404 siendo una pagina buena.
     */
    loadCategoria() {
      axios.get(`blog/${this.$route.params.id}?lang=${this.lang}`)
        .then(response => {
          if (this.destroyed) return;

          const noticias = response.data ? response.data.noticias : null;
          if (!noticias) {
            this.showNotFound();
            return;
          }

          this.notFound = false;
          this.no_post = true;
          this.noticias = noticias;
          window.prerenderReady = true;

          this.resolveNombreBackend();
        })
        .catch(error => {
          console.log(error);
          if (!this.destroyed) this.showNotFound(error);
        });
    },
    /**
     * Nombre de la categoria cuando no hay traduccion para su slug.
     *
     * `GET /blog/<slug>` no devuelve el nombre, asi que hay que pedir el
     * listado. Solo se hace en ese caso: con las categorias traducidas no se
     * paga ninguna peticion extra.
     */
    resolveNombreBackend() {
      const key = `blog.categorias_nombres.${this.$route.params.id}`;
      if (this.$t(key) !== key) return;

      axios.get(`blog?lang=${this.lang}`)
        .then(response => {
          if (this.destroyed) return;
          const categorias = (response.data && response.data.categorias) || [];
          for (let i = 0; i < categorias.length; i++) {
            if (categorias[i].slug === this.$route.params.id) {
              this.nombreBackend = categorias[i].nombre;
              return;
            }
          }
        })
        .catch(error => console.log(error));
    },
    /**
     * La categoria no se ha podido mostrar.
     *
     * Sin `error` la llamada viene de la propia validacion -el backend
     * respondio que la categoria no existe-, asi que es un 404. Con `error`,
     * solo lo es si el backend devolvio 404: cualquier otro fallo se declara
     * 503, para que una caida temporal no desindexe categorias buenas.
     */
    showNotFound(error) {
      let code = HTTP_NOT_FOUND;
      if (error) {
        const status = error.response ? error.response.status : null;
        code = status === HTTP_NOT_FOUND ? HTTP_NOT_FOUND : HTTP_SERVICE_UNAVAILABLE;
      }

      this.notFound = true;
      this.noticias = '';
      document.title = this.$t('error_404.nombre');

      if (code === HTTP_NOT_FOUND) {
        applyRobots(NOT_FOUND_ROUTE);
        clearCanonicalAndAlternates();
      }

      applyPrerenderStatus(NOT_FOUND_ROUTE, code);
      window.prerenderReady = true;
    }
  },
  computed : {
    ...mapGetters({
      lang: 'getLanguage',
    }),
    showPrimeras: function () {
    return this.noticias.slice(0, this.contador)
    },
    /**
     * Nombre visible de la categoria.
     *
     * vue-i18n devuelve la propia clave cuando no hay traduccion, y asi es como
     * `blog.categorias_nombres.importacion` acababa escrito en el intro y en la
     * miga de pan. Si falta la traduccion se usa el nombre del backend.
     */
    nombreCategoria: function () {
      const key = `blog.categorias_nombres.${this.$route.params.id}`;
      const traducido = this.$t(key);
      return traducido && traducido !== key ? traducido : this.nombreBackend;
    }
  },
  components: {
    'intro' : Intro,
    'noticia-el' : Noticia_el,
    'ultimas-noticias' : Ultimas_noticias,
    'error-404' : Error404
  }
}
</script>


// WEBPACK FOOTER //
// src/components/views/categoria-blog.vue